/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PracticeProfileUpdateDto
 */
export interface PracticeProfileUpdateDto {
    /**
     * Provider first name
     * @type {string}
     * @memberof PracticeProfileUpdateDto
     */
    firstName: string;
    /**
     * Provider middle name
     * @type {string}
     * @memberof PracticeProfileUpdateDto
     */
    middleName?: string;
    /**
     * Provider last name
     * @type {string}
     * @memberof PracticeProfileUpdateDto
     */
    lastName: string;
    /**
     * National Provider Identifier (NPI)
     * @type {string}
     * @memberof PracticeProfileUpdateDto
     */
    npi: string;
    /**
     * Provider phone number
     * @type {string}
     * @memberof PracticeProfileUpdateDto
     */
    phoneNumber: string;
    /**
     * Phone dial code (e.g. +1)
     * @type {string}
     * @memberof PracticeProfileUpdateDto
     */
    phoneNumberCountryCode?: string;
    /**
     * Phone country ISO alpha-2 code (e.g. US)
     * @type {string}
     * @memberof PracticeProfileUpdateDto
     */
    phoneNumberCountryIso2?: string;
    /**
     * Provider specialties
     * @type {Array<string>}
     * @memberof PracticeProfileUpdateDto
     */
    specialty?: Array<string>;
    /**
     * Provider profile picture URL
     * @type {string}
     * @memberof PracticeProfileUpdateDto
     */
    profileImage?: string;
    /**
     * Provider is active
     * @type {boolean}
     * @memberof PracticeProfileUpdateDto
     */
    isActive?: boolean;
    /**
     * RXNT Client ID for EHR integration
     * @type {string}
     * @memberof PracticeProfileUpdateDto
     */
    rxntClientId?: string;
    /**
     * RXNT Client Secret for EHR integration (sensitive - will not be returned in responses)
     * @type {string}
     * @memberof PracticeProfileUpdateDto
     */
    rxntClientSecret?: string;
    /**
     * RXNT Doctor ID for EHR integration
     * @type {string}
     * @memberof PracticeProfileUpdateDto
     */
    rxntDoctorId?: string;
}

/**
 * Check if a given object implements the PracticeProfileUpdateDto interface.
 */
export function instanceOfPracticeProfileUpdateDto(value: object): value is PracticeProfileUpdateDto {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('npi' in value) || value['npi'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    return true;
}

export function PracticeProfileUpdateDtoFromJSON(json: any): PracticeProfileUpdateDto {
    return PracticeProfileUpdateDtoFromJSONTyped(json, false);
}

export function PracticeProfileUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PracticeProfileUpdateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'middleName': json['middleName'] == null ? undefined : json['middleName'],
        'lastName': json['lastName'],
        'npi': json['npi'],
        'phoneNumber': json['phoneNumber'],
        'phoneNumberCountryCode': json['phoneNumberCountryCode'] == null ? undefined : json['phoneNumberCountryCode'],
        'phoneNumberCountryIso2': json['phoneNumberCountryIso2'] == null ? undefined : json['phoneNumberCountryIso2'],
        'specialty': json['specialty'] == null ? undefined : json['specialty'],
        'profileImage': json['profileImage'] == null ? undefined : json['profileImage'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'rxntClientId': json['rxntClientId'] == null ? undefined : json['rxntClientId'],
        'rxntClientSecret': json['rxntClientSecret'] == null ? undefined : json['rxntClientSecret'],
        'rxntDoctorId': json['rxntDoctorId'] == null ? undefined : json['rxntDoctorId'],
    };
}

export function PracticeProfileUpdateDtoToJSON(json: any): PracticeProfileUpdateDto {
    return PracticeProfileUpdateDtoToJSONTyped(json, false);
}

export function PracticeProfileUpdateDtoToJSONTyped(value?: PracticeProfileUpdateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstName': value['firstName'],
        'middleName': value['middleName'],
        'lastName': value['lastName'],
        'npi': value['npi'],
        'phoneNumber': value['phoneNumber'],
        'phoneNumberCountryCode': value['phoneNumberCountryCode'],
        'phoneNumberCountryIso2': value['phoneNumberCountryIso2'],
        'specialty': value['specialty'],
        'profileImage': value['profileImage'],
        'isActive': value['isActive'],
        'rxntClientId': value['rxntClientId'],
        'rxntClientSecret': value['rxntClientSecret'],
        'rxntDoctorId': value['rxntDoctorId'],
    };
}

